<div class="notfound-container">
  <h1>{{ "pageNotFound" | translate }}</h1>
  <p>{{ "weCantFindPage" | translate }}</p>

  <button nz-button nzType="default" (click)="goBack()">
    <i class="far fa-arrow-left mr-2"></i>{{ "goBack" | translate }}
  </button>
</div>
